// src/ui/aprovarComSimilar.js
// Modal de aprovacao com ANALISE DE QUALIDADE do nome (nao bloqueia, recomenda):
// duplicado/parecido (robusto a erro de digitacao), rascunho/teste, generico e curto.
import { el, clear } from '../lib/dom.js';
import { abrirModal } from './modal.js';
import { toast } from '../lib/toast.js';
import { analisarNome } from '../lib/similaridade.js';

const CAB = {
  ok: ['ph-check-circle', 'Nome especifico e sem parecidos - pode criar.'],
  atencao: ['ph-warning-circle', 'Da pra criar, mas vale revisar:'],
  forte: ['ph-warning', 'Recomendo NAO criar assim:'],
};

export function abrirAprovacao({ titulo, valorInicial, existentes, getNome, aoConfirmar, rotuloConfirmar = 'Criar' }) {
  const inp = el('input', { type: 'text', value: valorInicial || '' });
  const painel = el('div', { class: 'aprov-analise' });
  let btnCriar = null;

  function atualizar() {
    const r = analisarNome(inp.value, existentes, getNome);
    clear(painel);
    painel.className = 'aprov-analise aprov-analise--' + r.nivel;
    const [icone, frase] = CAB[r.nivel] || CAB.ok;
    painel.append(el('div', { class: 'aprov-analise__cab' }, [el('i', { class: 'ph ' + icone }), el('span', { text: ' ' + frase })]));
    r.motivos.forEach((m) => painel.append(el('div', { class: 'aprov-analise__motivo', text: '- ' + m.texto })));
    if (r.similares.length) {
      painel.append(el('div', { class: 'aprov-analise__tit', text: r.topPct >= 85 ? 'Provavel duplicado:' : 'Ja existe parecido:' }));
      r.similares.forEach((x) => painel.append(el('div', { class: 'aprov-similar__item' }, [
        el('span', { text: x.nome }), el('span', { class: 'aprov-similar__pct', text: x.pct + '%' }),
      ])));
    }
    if (btnCriar) {
      btnCriar.textContent = r.nivel === 'forte' ? `${rotuloConfirmar} mesmo assim` : rotuloConfirmar;
      btnCriar.classList.toggle('btn--perigo', r.nivel === 'forte');
      btnCriar.classList.toggle('btn--primario', r.nivel !== 'forte');
    }
  }

  inp.addEventListener('input', atualizar);
  const ref = abrirModal({
    titulo,
    corpo: [
      el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Confira e ajuste o texto antes de salvar. O sistema analisa o nome e avisa (nao bloqueia - voce decide).' }),
      el('div', { class: 'campo' }, [el('label', { text: 'Nome' }), inp]),
      painel,
    ],
    acoes: [
      { rotulo: 'Cancelar', classe: 'btn' },
      { rotulo: rotuloConfirmar, classe: 'btn btn--primario', onClick: async () => {
        const v = (inp.value || '').trim();
        if (!v) { toast('Informe o nome.', 'erro'); return false; }
        return await aoConfirmar(v);
      } },
    ],
  });
  btnCriar = ref.el.querySelector('.modal__foot .btn--primario');
  atualizar();
}